import { forwardRef } from 'react';
import { Chip, type ChipProps } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';
interface BetaChipProps extends ChipProps {
  variant?: 'filled' | 'outlined';
}
export const BetaChip = forwardRef<HTMLSpanElement, BetaChipProps>((props, ref) => {
  const {
    className,
    variant = 'filled',
    ...rest
  } = props;
  return <Chip ref={ref} size="xs" rounded="full" className={cn('border text-alternative', variant === 'outlined' && 'bg-default border-opacity-black-2', variant === 'filled' && 'bg-neutral border-opacity-assistive', className)} {...rest}>
        Beta
      </Chip>;
});
BetaChip.displayName = 'BetaChip';